/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SignUpQueryVariables = {};
export type SignUpQueryResponse = {
    readonly configuration: {
        readonly collectNameOnSignUp: boolean;
        readonly passwordValidationRegex: string | null;
        readonly passwordValidationMessage: string | null;
        readonly licensingRecaptchaSiteKey: string | null;
        readonly licensingRecaptchaSiteKeyV3: string | null;
    } | null;
};
export type SignUpQuery = {
    readonly response: SignUpQueryResponse;
    readonly variables: SignUpQueryVariables;
};



/*
query SignUpQuery {
  configuration {
    collectNameOnSignUp
    passwordValidationRegex
    passwordValidationMessage
    licensingRecaptchaSiteKey
    licensingRecaptchaSiteKeyV3
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectNameOnSignUp",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationRegex",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationMessage",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licensingRecaptchaSiteKey",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licensingRecaptchaSiteKeyV3",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "SignUpQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SignUpQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "a5160a33a8a1840ebb8e874dcb99af9b",
            "id": null,
            "metadata": {},
            "name": "SignUpQuery",
            "operationKind": "query",
            "text": "query SignUpQuery {\n  configuration {\n    collectNameOnSignUp\n    passwordValidationRegex\n    passwordValidationMessage\n    licensingRecaptchaSiteKey\n    licensingRecaptchaSiteKeyV3\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a21826600eebe9d68f911b34d9061076';
export default node;
